// Bootstrap VFS for the viewer. Sources come from the generated
// default-source bundle (examples/demo embedded at build time).
//
// When the file-picker UI lands, callers should pass user-selected
// sources to useModel instead of DEFAULT_VFS, falling back to this
// constant only when the user hasn't opened anything yet.

import type { Vfs } from "@archlang/viewer-core";
import {
  DEFAULT_SOURCE_FILES,
  DEFAULT_SOURCE_ASSETS_B64,
} from "./generated/default-source.js";
import { type Assets, base64ToBytes } from "./workspaceAssets.js";

export const DEFAULT_VFS: Vfs = DEFAULT_SOURCE_FILES;

/** Demo image assets, decoded from the generated base64 bundle to bytes. */
export const DEFAULT_ASSETS: Assets = new Map(
  [...DEFAULT_SOURCE_ASSETS_B64].map(([path, b64]) => [path, base64ToBytes(b64)]),
);
